import AnswerAttribute from './AnswerAttribute';
export default AnswerAttribute;